import React, { Component } from 'react';
import { Route } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import _load from './load.gif';
require('bootstrap')

class Queues extends Component {
    constructor() {
        super();
       
        this.state = {
            data: [],
            searchedData: [],
            search: ''
        };
    }
    componentDidMount = () => {
        fetch('Admin/GetQueues').then(x => x.json()).then(x => this.setState({ data: x, searchedData: x }));
    }

    searchE = (e) => {
        this.setState({ search: e.target.value });
        if (e.target.value.lenght === 0) {
            this.setState({ searchedData: this.state.data });
        } else {
            var re = new RegExp(e.target.value, 'i');
            var arr = [];
            this.state.data.forEach(function (item) {
                if (item.userId !== undefined && item.userId !== null) {
                    if (item.userId.toString().match(re)) {
                        arr.push(item);
                    }
                }
               
            });
            this.setState({ searchedData: arr });
        }
        
    }

    getCertName = (id) => {
        var certs = [
            ["9", "Новус"],
            ["10", "Комфі"],
            ["11", "Фокстрот"],
            ["19", "Епіцентр"],
            ["44", "Эльдорадо 500"],
            ["79", "Бомонд"],
            ["80", "Сільпо"],
            ["187", "Алло"],
            ["245", "ОККО 500"],
            ["258", "Планета кіно"],
            ["265", "Пандора 500"],
            ["281", "Якабу"],
            ["288", "Аптека"],
            ["300", "Андер Армор"],
            ["345", "Концерт Юа"],
            ["346", "Локаль"],
            ["396", "Золотий Вік 500"],
            ["459", "Гастрофемілі"],
            ["301", "МД Фешн 500"],
            ["490", "Мультиплекс"],
            ["140", "Вайнтайм 500"],
            ["10001", "Ля Фамілія"],
            ["10002", "Флорум"],
            ["10003", "Спортлайф"],
            ["10004", "Репортер"],
            ["10005", "Артист"],
            ["10006", "Коаст"],
            ["10007", "Будинок Іграшок"],
            ["10008", "Унмоменто"],
            ["10009", "Такси"],
            ["10010", "Планета кино 100 x5"],
            ["10011", "Comfy на 100"],
            ["10012", "Comfy на 200"],
            ["10013", "Епіцентр на 100"],
            ["10014", "Епіцентр на 250"],
            ["10015", "Алло на 100"],
            ["10016", "АШАН на200"],
            ["10017", "Novus на 100"],
            ["10018", "Novus на 200"],
            ["10019", "Планета Кино на 200"],
            ["10020", "Watson на 100"],
            ["10021", "Watson на 250"],
            ["10023", "WOG на 100"],
            ["10024", "WOG на 200"],
            ["10025", "Планета кино 100"],
            ["10026", "Giftmall 100"],
            ["10027", "Giftmall 200"],
            ["10028", "Giftmall 300"],
            ["10029", "Giftmall 400"],
            ["10030", "Giftmall 500"],
            ["10033", "Будинок іграшок 100"],
            ["10034", "Будинок іграшок 250"],
            ["10035", "Yakaboo 200"],
            ["10036", "Yakaboo 300"],
            ["10229", "Eva 100"],
            ["10031", "JYSK 100"],
            ["10032", "JYSK 250"],
            ["10037", "Аптека 100"],
            ["10038", "Аптека 200"],
            ["10039", "Вайнтайм 250"],
            ["228", "Eva 300"],
            ["10040", "Readeat 300"]
        ];
        for (var i = 0; i < certs.length; i++) {
            if (parseInt(certs[i][0]) === id) {
                return certs[i][1];
            }
        }
    }
     render() {
        return (
            <div className="">
                <input value={this.state.search} onInput={this.searchE} type="search" />
                <table className="table">
                    <tr>
                        <th>Id</th>
                        <th>Время</th>
                        <th>Подтвержден</th>
                        <th>Закончен</th>
                        <th>Сертификат</th>
                        <th>UserId</th>
                    </tr>
                    {this.state.searchedData.map(x =>
                        <tr>
                            <td>{x.id}</td>
                            <td>{x.time}</td>
                            <td>{x.confirmed ? "Да" : "Нет"}</td>
                            <td>{x.ended ? "Да" : "Нет"}</td>
                            <td>{this.getCertName(x.type)}</td>
                            <td>{x.userId == undefined || null ? -1 : x.userId}</td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }

}
export default Queues;


